import { TextField } from '@material-ui/core';
import FormControl from '@material-ui/core/FormControl';
import { isArray } from '@material-ui/data-grid';
import { Autocomplete } from '@material-ui/lab';
import FilterCard from 'Components/Editor/Details/Filters/FilterCard';
import FilterCardBrandLogoSelect from 'Components/Editor/Details/Filters/FilterCardBrandLogoSelect';
import FilterCardBrandTextSelect from 'Components/Editor/Details/Filters/FilterCardBrandTextSelect';
import Brand from 'Models/Brands/Brand';
import EditorVideoDetection from 'Models/Videos/Detections/EditorVideoDetection';
import { ReactElement, useMemo } from 'react';

interface FilterCardBrandsProps {
	brands: Brand[];
	selectedBrands: Brand[] | null;
	onSelectedBrandsChanged: (brands: Brand[] | null) => void;
	selectedTexts: number[] | null;
	onSelectedTextsChanged: (ids: number[] | null) => void;
	selectedLogos: number[] | null;
	onSelectedLogosChanged: (ids: number[] | null) => void;
	selectedDetections: EditorVideoDetection[];
}

const FilterCardBrands = (props: FilterCardBrandsProps): ReactElement => {
	const sortedBrands = useMemo(() => props.brands.sort((a, b) => a.name.localeCompare(b.name)), [props.brands]);
	const isChecked = props.selectedBrands !== null;
	const displayTextOrLogoSelect = props.selectedBrands !== null && props.selectedBrands.length === 1;
	const singleSelectedBrand = props.selectedBrands?.length === 1 ? props.selectedBrands[0] : null;

	const handleCheckedChanged = (checked: boolean): void => {
		const selectedBrandIds = props.selectedDetections.map((x) => x.brandId);
		const defaultValue = props.brands.filter((x) => selectedBrandIds.includes(x.id)).map((x) => x);
		if (checked) props.onSelectedBrandsChanged(defaultValue);
		else props.onSelectedBrandsChanged(null);
	};

	const handleBrandsSelectionChanged = (_: Object, brands: Brand | Brand[]): void => {
		if (isArray(brands)) {
			props.onSelectedBrandsChanged(brands);
		} else {
			console.error(`expected number array but instead got 'target.value'`);
		}
	};

	const handleSelectedTextIdsChanged = (ids: number[]): void => {
		props.onSelectedTextsChanged(ids);
	};

	const handleSelectedLogoIdsChanged = (ids: number[]): void => {
		props.onSelectedLogosChanged(ids);
	};

	return (
		<FilterCard name={'Select brands'} onCheckedChanged={handleCheckedChanged} isChecked={isChecked}>
			<FormControl fullWidth={true} margin="normal">
				<Autocomplete
					multiple={true}
					renderInput={(params) => <TextField {...params} label="Brands" fullWidth={true} />}
					options={sortedBrands}
					fullWidth={true}
					getOptionLabel={(option) => option.name}
					autoHighlight={true}
					onChange={handleBrandsSelectionChanged}
					value={props.selectedBrands ?? []}
				/>
			</FormControl>
			<FilterCardBrandTextSelect
				displayContent={displayTextOrLogoSelect}
				brand={singleSelectedBrand}
				selectedTextIds={props.selectedTexts ?? []}
				onSelectedTextIdsChanged={handleSelectedTextIdsChanged}
			/>
			<br />
			<FilterCardBrandLogoSelect
				brand={singleSelectedBrand}
				onSelectedLogoIdsChanged={handleSelectedLogoIdsChanged}
				selectedLogoIds={props.selectedLogos ?? []}
				displayContent={displayTextOrLogoSelect}
			/>
		</FilterCard>
	);
};

export default FilterCardBrands;
